const settings = {
    default: {
        api_prefix: 'https://chatbot.local.rc3.dev.ring.com',
    },
    'chatbot.local.rc3.dev.ring.com': {
        api_prefix: 'https://chatbot.local.rc3.dev.ring.com',
    },
    'chatbot.rc3.dev.ring.com': {
        api_prefix: 'https://chatbot.rc3.dev.ring.com',
    },
    'chatbot.rc3.qa.ring.com': {
        api_prefix: 'https://chatbot.rc3.qa.ring.com',
    },
    'chatbot.rc3.ring.com': {
        api_prefix: 'https://chatbot.rc3.ring.com',
    },
};

const safeWindow = typeof window !== 'undefined' ? window : undefined;

const settingEnv = (settings as any)[safeWindow?.location.host || 'default'] || settings.default;

export const {
    api_prefix: apiPrefix,
}: {
    api_prefix: string;
} = settingEnv;
